import { render, staticRenderFns } from "./SubCompaniesList.vue?vue&type=template&id=1a3c83d8&scoped=true&"
import script from "./SubCompaniesList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SubCompaniesList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3c83d8",
  null
  
)

export default component.exports